export const PRIMENG_ES_ES = {
  selectionMessage: '{0} elementos seleccionados',
  emptySelectionMessage: 'Ningún elemento seleccionado',
  emptySearchMessage: 'No se encontraron resultados',
  emptyFilterMessage: 'No se encontraron resultados',
  emptyMessage: 'No hay opciones disponibles',

  // Calendario
  dayNames: [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
  ],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
  monthNames: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  monthNamesShort: [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
  ],
  today: 'Hoy',
  weekHeader: 'Sem',
  firstDayOfWeek: 1,

  // Botones comunes
  clear: 'Limpiar',
  apply: 'Aplicar',
  choose: 'Elegir',
  upload: 'Subir',
  cancel: 'Cancelar',
  close: 'Cerrar',

  // Filtros
  matchAll: 'Coincidir Todo',
  matchAny: 'Coincidir Cualquiera',
  addRule: 'Agregar Regla',
  removeRule: 'Eliminar Regla',
  accept: 'Sí',
  reject: 'No',

  // Paginación
  aria: {
    pageLabel: 'Página {page}',
    firstPageLabel: 'Primera Página',
    lastPageLabel: 'Última Página',
    nextPageLabel: 'Página Siguiente',
    previousPageLabel: 'Página Anterior',
    slideNumber: 'Slide {slideNumber}',
  },

  // FileUpload
  chooseLabel: 'Elegir',
  uploadLabel: 'Subir',
  cancelLabel: 'Cancelar',

  // Mensajes
  weak: 'Débil',
  medium: 'Media',
  strong: 'Fuerte',
  passwordPrompt: 'Ingrese una contraseña',

  // Filtros de tabla
  startsWith: 'Comienza con',
  contains: 'Contiene',
  notContains: 'No contiene',
  endsWith: 'Termina con',
  equals: 'Igual',
  notEquals: 'Diferente',
  noFilter: 'Sin Filtro',
  lt: 'Menor que',
  lte: 'Menor o igual a',
  gt: 'Mayor que',
  gte: 'Mayor o igual a',
  dateIs: 'La fecha es',
  dateIsNot: 'La fecha no es',
  dateBefore: 'Fecha anterior a',
  dateAfter: 'Fecha posterior a',
};
